import './base/';
import './sliders/product-slider';
import './sliders/products-slider';
import './productFaq/handleMobileProductFaqItem';
import './productFaq/mobileProductFaqItemToggle';
import './productQuantity/initProductQuantity';
import './relatedProducts/initRelatedProducts';
import './accordion/initAccordions';
import './mobileNavigation/initMobileNavigation';
import './mobileNavigation/initMobileNavigationDropdown';
import './subscribe/initSubscribeButton';
import './tabs/initTabs';
import './processSteps/handleProcessSteps';
import './animations/fade-in';
import './utils/anchors';
import './utils/clicks';
import './product/quantity';
import './product/ajax-actions';
import './cart/cart';
import './utils/set-real-vh-units';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed

const handleAnimate = ($container, trigger, offset, duration, pin) => {
	const controller = new ScrollMagic.Controller();
	let obj = { curImg: 0 };
	const images = [];

	$container.find('.section-animate__image').each(function(index, el) {
		images.push($(this));
	});

	const tween = TweenMax.to(obj, 1,
		{
			curImg: images.length - 1,
			roundProps: "curImg",
			onUpdate: function () {
			  images[obj.curImg].addClass('is-current').siblings().removeClass('is-current');
			}
		}
	);

	const scene = new ScrollMagic.Scene({ triggerElement: trigger, offset: offset, duration: duration })
						.setPin(pin)
						.setTween(tween)
						.addTo(controller);
}

const handleSlicesAnimation = () => {
	const $container = $('#section-animate-1');

	if ($container.length === 0) {
		return;
	}

	const offset = $container.outerHeight() / 2;
	const trigger = '#section-animate-1';
	const duration = '400%';
	const pin = '#section-animate-1';

	handleAnimate($container, trigger, offset, duration, pin);
}

const handleSlicesAnimationTexts = () => {
	const $container = $('#section-animate-1');

	if ($container.length === 0) {
		return;
	}

	const controller = new ScrollMagic.Controller();
	const texts = [];
	const offset = $container.outerHeight() / 2;
	const trigger = '#section-animate-1';
	const duration = '250%';
	const pin = '#section-texts';
	let obj = { curText: 0 };

	$container.find('.section-animate__text').each(function(index, el) {
		texts.push($(this));
	});

	const tween = TweenMax.to(obj, 1,
		{
			curText: texts.length - 1,
			roundProps: "curText",
			onUpdate: function () {
			  texts[obj.curText].addClass('is-current').removeClass('is-animated').siblings().removeClass('is-current');

			  texts[obj.curText].prevAll().addClass('is-animated');
			},
			onComplete: function () {
				texts[obj.curText].removeClass('is-current').addClass('is-animated');
			}
		}
	);

	const scene = new ScrollMagic.Scene({ triggerElement: trigger, offset: offset, duration: duration })
						.setTween(tween)
						.addTo(controller);
}

const handleCamoAnimations = () => {
	const $container = $('#package-animation');

	if ($container.length === 0) {
		return;
	}

	const controller = new ScrollMagic.Controller();
	const texts = [];
	const offset = $container.outerHeight() / 2;
	const trigger = '#package-animation';
	const duration = '400%';
	const pin = '#package-animation';
	let obj = { curText: 0 };

	$container.find('.package__text').each(function(index, el) {
		texts.push($(this));
	});

	const tween = TweenMax.to(obj, 1,
		{
			curText: texts.length - 1,
			roundProps: "curText",
			onUpdate: function () {
				$container.find('.package__title .package__background').eq(obj.curText).addClass('is-current').siblings().removeClass('is-current').removeClass('is-animated');
				$container.find('.package__title .package__background').eq(obj.curText).prevAll().addClass('is-animated');
				$container.find('.package__image .package__background').eq(obj.curText).addClass('is-current').siblings().removeClass('is-current').removeClass('is-animated');
				$container.find('.package__image .package__background').eq(obj.curText).prevAll().addClass('is-animated');
				$container.find('.package__texts .package__text').eq(obj.curText).addClass('is-current').siblings().removeClass('is-current');
				$container.find('.package__entries .package__entry').eq(obj.curText).addClass('is-current').siblings().removeClass('is-current');
			}
		}
	);

	const scene = new ScrollMagic.Scene({ triggerElement: trigger, offset: offset, duration: duration })
						.setPin(pin)
						.setTween(tween)
						.addTo(controller);
}

const handleFeaturesAnimations = () => {
	const $container = $('.section-features-alt');

	if ($container.length === 0) {
		return;
	}

	if ($win.outerWidth() >= 1024) {
		const controller = new ScrollMagic.Controller();
		const texts = [];
		const offset = $container.outerHeight() / 2;
		const trigger = '.section-features-alt';
		const duration = '400%';
		const pin = '.section-features-alt';
		let obj = { curText: 0 };

		$container.find('.accordion__section').each(function(index, el) {
			texts.push($(this));
		});

		const tween = TweenMax.to(obj, 1,
			{
				curText: texts.length - 1,
				roundProps: "curText",
				onUpdate: function () {
					const $accordionSection = $container.find('.accordion-alt .accordion__section');
					const $currentAccordionSection = $accordionSection.eq(obj.curText);

					$currentAccordionSection
						.addClass('is-current')
						.find('.accordion__body')
						.slideDown()
						.closest('.accordion__section')
						.siblings()
						.removeClass('is-current')
						.find('.accordion__body')
						.slideUp();

					if ($currentAccordionSection.data('color')) {
						$(`#${$currentAccordionSection.data('section-id')}`).attr('data-color', $currentAccordionSection.data('color'));
					}

					if (!$container.find('.accordion-alt .is-current').length) {
						$(`#${$currentAccordionSection.data('section-id')}`).attr('data-color', '');
					}

					$container.css('top', '');
				}
			}
		);

		const scene = new ScrollMagic.Scene({ triggerElement: trigger, offset: offset, duration: duration })
							.setPin(pin)
							.setTween(tween)
							.addTo(controller);

		let resizeTimeout;

		$win.on('resize', function(){
			const isAnimationEnable = $win.outerWidth() < 1024;

			if (resizeTimeout) clearTimeout(resizeTimeout);

			resizeTimeout = setTimeout(function(){
				if (isAnimationEnable) {
					scene.destroy(true)
						.removePin(true);
				} else {
					scene.refresh()
					.removePin(true)
					.setPin(pin)
					.refresh();
				}
			}, 100);
		});
	}

	$win.on('resize', function(){
		if ($win.outerWidth() >= 1024) {
			handleFeaturesAnimations();
		}
	});
}

$win.on('load', function() {
	handleSlicesAnimation();

	handleSlicesAnimationTexts();

	handleCamoAnimations();

	handleFeaturesAnimations();

	$('.section-animate').closest('.scrollmagic-pin-spacer').addClass('scrollmagic-container');
});
